export enum SOUNDS_TYPE {
  SOUNDS = 'SOUNDS',
  SONIDOS = 'SONIDOS',
}

export const soundKeys = {
  [SOUNDS_TYPE.SOUNDS]: 'sounds',
  [SOUNDS_TYPE.SONIDOS]: 'sonidos',
}

export const ALL_SOUNDS = 'All sounds'
export const ALL_SOUNDS_ORDER = [
  13, // name = '/m/'
  1, // name = '/a/'
  20, // name = '/t/'
  4, // name = '/d/'
  15, // name = '/o/'
  3, // name = '/k/ > c'
  7, // name = '/g/'
  9, // name = '/i/'
  14, // name = '/n/'
  8, // name = '/h/'
  19, // name = '/s/'
  6, // name = '/f/'
  22, // name = '/v/'
  26, // name = '/z/'
  16, // name = '/p/'
  5, // name = '/e/'
  2, // name = '/b/'
  12, // name = '/l/'
  18, // name = '/r/'
  21, // name = '/u/'
  23, // name = '/w/'
  10, // name = '/j/'
  25, // name = '/y/'
  24, // name = '/x/'
  11, // name = '/k/ > k'
  30, // name = '/ch/'
  41, // name = '/sh/'
  42, // name = '/th/'
  43, // name = '/th/'
  17, // name = '/qu/'
  34, // name = '/ng/'
  31, // name = '/ee/'
  27, // name = '/ae/'
  33, // name = '/ie/'
  35, // name = '/oe/'
  44, // name = '/ue/'
  37, // name = '/oo/'
  38, // name = '/oo/'
  40, // name = '/ou/'
  36, // name = '/oi/'
  29, // name = '/aw/'
  32, // name = '/er/'
  28, // name = '/ar/'
  39, // name = '/or/'
  45, // name = '/e/ + /l/'
]
